import script from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./VideoStylePanel.vue?vue&type=style&index=0&id=b3551c8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3551c8c"]])

export default __exports__